import React from "react";
import {
    WEEKDAYS_SHORT
} from '../../../../constants';
import { isSet } from "../../../../../../utils/commonUtils";
import { calendarWidgetVisitTypeBasedColor } from "../../../../calendarFunctions";

const MonthDayContent = (props) => {
  const { listItem, keyIndex, showMoreDetailsDataHandler, todayDate } = props;

  return (
    <div className="fc-content-skeleton" key={keyIndex}>
      <table>
        <MonthDayContentHeader
          todayDate={todayDate}
          listItem={listItem}
          addVisitToogleHandler={props.addVisitToogleHandler}
          blockedDates={props.blockedDates}
          blockedDays={props.blockedDays} // ⬅ pass here
        />
        <tbody>
          <tr>
            {listItem.map((dateItem, itemIndex) => {
              let getDateRecords = [];
              try {
                getDateRecords = isSet(
                  props.calendarRecords[dateItem.c_date],
                  []
                );
              } catch (e) {}

              // const hasRecords = getDateRecords.length > 0;

              // 🔹 Keep your existing classes
              let classArr = [];
              let isBlocked = false;

              // Holiday check
              const holiday = props.blockedDates?.find(
                (b) => b.date === dateItem.c_date
              );
              if (holiday) {
                isBlocked = true;
              }

              // Weekday block check
              const weekdayNames = [
                "SUN",
                "MON",
                "TUE",
                "WED",
                "THU",
                "FRI",
                "SAT",
              ];
              const weekdayName =
                weekdayNames[new Date(dateItem.date).getDay()];
              if (props.blockedDays?.includes(weekdayName)) {
                isBlocked = true;
              }

              // Empty cell check
              // if (!hasRecords) {
              //   isBlocked = true;
              // }

              return (
                <td
                  key={itemIndex}
                  title={
                    holiday
                      ? holiday.reason
                      : ""
                  }
                  onClick={() => {
                    if (!isBlocked) {
                      props.addVisitToogleHandler({
                        visit_date: dateItem.c_date,
                      });
                    }
                  }}
                >
                  {getDateRecords.map((item, ind) => {
                    if (ind > 2) return null;
                    const typeBasedClass = calendarWidgetVisitTypeBasedColor(
                      item.visit_category,
                      'GRID',
                      item.visit_status
                    );
                    return (
                      <>
                        <a
                         key={ind}
                          title={`${item.visit_time} : ${item.employee.first_name} ${item.employee.last_name}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            props.showQuickVisitView(e, item);
                          }}
                        >
                          <div
                            className={`mainValueTag ${typeBasedClass}`}
                            data-toggle="dropdown"
                          >
                            <span className="text-sm font-weight-bold">
                              {item.visit_time}
                            </span>
                            <span className="text-xs font-weight-bold">
                              {" "}
                              :{" "}
                            </span>
                            <span className="text-sm">
                              {item.employee.first_name}{" "}
                              {item.employee.last_name}
                            </span>
                          </div>
                        </a>
                        {ind === 2 && getDateRecords.length > 3 && (
                          <a
                            className="text-danger textUnderline text-small quick-sidebar-toggler cursor-pointer"
                            onClick={(e) =>
                              props.showMoreDetailsDataHandler(
                                e,
                                { date: dateItem.c_date, time: "" },
                                getDateRecords
                              )
                            }
                          >
                            + More ...
                          </a>
                        )}
                      </>
                    );
                  })}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const MonthDayContentHeader = ({
  listItem,
  addVisitToogleHandler,
  todayDate,
  blockedDates = [],
  blockedDays = [],
}) => {
  const weekdayNames = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  return (
    <thead>
      <tr>
        {listItem.map((item, itemIndex) => {
          let classArr = [
            "fc-day-top",
            "fc-" + WEEKDAYS_SHORT[itemIndex]+"",
            "fc-past",
          ];
          if (!item.currentMonth) {
            classArr.push("fc-other-month");
          }
          if (
            new Date(todayDate).setHours(0, 0, 0, 0) ===
            new Date(item.date).setHours(0, 0, 0, 0)
          ) {
            classArr.push("fc-day-today");
          }

          // ✅ Holiday check
          const holiday = blockedDates.find((b) => b.date === item.c_date);

          // ✅ Weekday block check
          const weekdayName = weekdayNames[new Date(item.date).getDay()];
          const weekdayBlocked = blockedDays.includes(weekdayName);

          let isBlocked = false;
          let reason = "";

          if (holiday) {
            isBlocked = true;
            reason = holiday.reason;
          } else if (weekdayBlocked) {
            isBlocked = true;
            reason = "Not Available";
          }

          if (isBlocked) {
            classArr.push("fc-day-blocked");
          }

          return (
            <td
              className={classArr.join(" ")}
              key={itemIndex}
              data-date={item.date}
              title={reason}
              onClick={() => {
                if (!isBlocked) {
                  addVisitToogleHandler({ visit_date: item.c_date });
                }
              }}
            >
              <span className="fc-day-number">{item.number}</span>
              {holiday && <div className="holiday-label">{holiday.reason}</div>}
            </td>
          );
        })}
      </tr>
    </thead>
  );
};

MonthDayContent.defaultProps = {
    isShowActivities:false,
}
export default MonthDayContent;